import { Reducer } from 'redux';
import { IFlashMessageState, IShowFlashMessageDataAction } from '../actions/flashMessageAction';
import { FlashMessageActionTypes } from '../constants/actionTypes';

const initialState: IFlashMessageState = {
  message: '',
  style: 'error',
};

const flashMessageReducer: Reducer<IFlashMessageState, IShowFlashMessageDataAction> = (
  state = initialState,
  action: IShowFlashMessageDataAction,
) => {
  switch (action.type) {
    case FlashMessageActionTypes.SHOW_FLASH_MESSAGE:
      return {
        ...state,
        message: action.message,
        style: action.style,
      };
    default: return state;
  }
};

export default flashMessageReducer;
